// extracted by mini-css-extract-plugin
module.exports = {"link":"jgp-2USTt","mapContainer":"jgp-391iG"};